import Home from "./Component/Home";

function App() {
  return (
    <Home/>
  );
}

export default App;
